import Breadcrumbs from "@/components/Breadcrumbs";
import { Box, Divider } from "@mui/material";
import DownloadManager from "./components/DownloadManager";

const breadcrumbs = [
    {
        to: "../..",
        title: "Administration",
    },
    {
        title: "Media",
        to: "",
    },
    {
        title: "Downloads",
        to: "downloads",
    },
];

const Media = () => {
    return (
        <Box>
            <Breadcrumbs trail={breadcrumbs} />
            <Divider />
            <DownloadManager />
        </Box>
    );
};

export default Media;
